'use client';
import { UsageDemo } from './main/UsageDemo';
import { MultilingualSection } from './main/MultilingualSection';
import { SecuritySection } from './main/SecuritySection';
import { ToolsSection } from './main/ToolsSection';
import { AppSupportSection } from './main/AppSupportSection';
import { TrySection } from './main/TrySection';
import { MainHeader } from './main/MainHeader';
import { Demo } from './main/Demo';
import { Partner } from './main/Partner';
import { CaseStudyList } from './main/CaseStudy';
import analyticsInstance from 'libs/rtzr-commons/modules/marketing/Analytics';
import { useEffect } from 'react';
import { useLocale } from 'app/[locale]/hooks/useTranslate';
import { AIChatSection } from './main/AIChatSection';
import { AccessSection } from './main/AccessSection';
import { SafeSection } from './main/SafeSection';
import { AuditLogSection } from './main/AuditLogSection';

export const HomepageComponent = (): JSX.Element => {
  const locale = useLocale();
  useEffect(() => {
    analyticsInstance.logEvent('page_homepage');
  }, []);

  return (
    <div className="space-y-20 md:space-y-[120px] pt-4 pb-14 md:pt-10 md:pb-[120px]">
      <div className="space-y-14 md:space-y-[60px]">
        <MainHeader />
        <Demo />
        <Partner />
      </div>
      <SecuritySection />
      <ToolsSection />
      <MultilingualSection />
      <AIChatSection />
      <div>
        <div className="h-8 md:h-24 pastel-gradient-box" />
        <div className="h-0.5 bg-gradient-box-color" />
        <div className="relative bg-[#1E1E1E] py-20 md:py-48 space-y-40">
          <AccessSection />
          <SafeSection />
          <div className="absolute bottom-20 left-1/2 right-1/2 -translate-x-1/2 w-full max-w-[568px] h-[308px] bg-white bg-opacity-[8%] rounded-full blur-3xl" />
        </div>
      </div>
      <AuditLogSection />
      <UsageDemo />
      {locale === 'ko' && <CaseStudyList />}
      <AppSupportSection />
      <TrySection />
    </div>
  );
};
